/**
 * Retorna um fingerprint estável baseado em UUID persistido no localStorage.
 * Imune a DevTools, emulação de dispositivo ou mudanças de UserAgent.
 */
export function getDeviceFingerprint() {
  const KEY = 'climorax_device_id';
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(KEY, id);
  }
  return id;
}

/**
 * Retorna um nome legível para o dispositivo atual.
 * Usa navigator.platform (imune ao DevTools) para detectar o OS
 * e navigator.userAgent apenas para identificar o navegador.
 */
export function getDeviceName() {
  const ua = navigator.userAgent;
  const cap = window.Capacitor;

  if (cap?.isNativePlatform?.()) {
    const platform = cap.getPlatform?.();
    return platform === 'ios' ? 'App iOS' : 'App Android';
  }

  // platform é imune à emulação do DevTools
  const platform = navigator.platform || '';

  let os;
  if (/Win/.test(platform)) os = 'Windows';
  else if (/iPhone|iPad/.test(platform)) os = /iPad/.test(platform) ? 'iPad' : 'iPhone';
  else if (/Android/.test(platform) || /Linux/.test(platform) && /Android/.test(ua)) os = 'Android';
  else if (/Mac/.test(platform)) os = 'Mac';
  else if (/Linux/.test(platform)) os = 'Linux';
  else os = 'Dispositivo';

  let browser;
  if (/Edg\//.test(ua)) browser = 'Edge';
  else if (/Firefox/.test(ua)) browser = 'Firefox';
  else if (/Chrome/.test(ua)) browser = 'Chrome';
  else if (/Safari/.test(ua)) browser = 'Safari';
  else browser = 'Navegador';

  if (os === 'iPhone' || os === 'iPad') return `${os} (${browser})`;
  return `${os} (${browser})`;
}

/** Número máximo de dispositivos por plano */
export function getLimiteDispositivos(plano) {
  const limites = {
    starter: 2,
    essential: 3,
    professional: 5,
    management: 10,
    premium: 2,
    pro: 2,
  };
  return limites[plano] ?? null;
}

/** Dispositivos de acesso mais antigo a remover para que um novo caiba no limite. */
export function selecionarDispositivosParaSubstituir(dispositivos, limite) {
  if (limite === null || limite === undefined) return [];
  const lista = dispositivos || [];
  const excedente = lista.length - limite + 1;
  if (excedente <= 0) return [];
  const instante = item => Number(new Date(item.ultimo_acesso || item.criado_em)) || 0;
  return [...lista].sort((a, b) => instante(a) - instante(b)).slice(0, excedente);
}
